import { apiClient } from "@base/api/client";
import type { UseQueryOptions } from "@tanstack/react-query";
import { useQuery } from "@tanstack/react-query";
import { z } from "zod";

const dailyLogShareResponseSchema = z.object({
  share_token: z.string(),
});

async function issueDailyLogShareToken(projectId: string, logId: string): Promise<string> {
  const response = await apiClient.post<unknown>(
    `/project-management/api/projects/${projectId}/daily-logs/${logId}/share`,
  );
  return dailyLogShareResponseSchema.parse(response.data).share_token;
}

// POST지만 서버가 일지마다 토큰을 한 번만 발급하고 이후엔 같은 값을 돌려주므로 query로 캐시한다.
export function dailyLogShareTokenQueryOptions(projectId: string, logId: string) {
  return {
    queryKey: ["daily-log-share-token", projectId, logId] as const,
    queryFn: () => issueDailyLogShareToken(projectId, logId),
    staleTime: Number.POSITIVE_INFINITY,
  };
}

export function useDailyLogShareTokenQuery(
  projectId: string,
  logId: string,
  options?: Omit<UseQueryOptions<string>, "queryKey" | "queryFn">,
) {
  return useQuery({
    ...dailyLogShareTokenQueryOptions(projectId, logId),
    ...options,
  });
}
